//Need to pass a capability to open the alt products modal down a few layers to Suggested Products, so using Context.
import React from 'react';
import { ICommit } from '../../@types/editableDataGridTypes';
import { ISalesOrderLine } from '../../graphql/schema/p4types';

const SalesOrderContext = React.createContext({} as SalesOrderContextType);
export default SalesOrderContext;

export type SalesOrderContextType = {
  vatInclusive?: boolean;
  onRowUpdated?: (commit: ICommit<ISalesOrderLine>) => void;
  createSpecialOrderProduct?: (
    id: number,
    rowIdx: number,
    options: { dataid: string; fieldNameOverride?: string }
  ) => void;
  setReturnOrderModalState?: (
    value: ((prevState: { modalOpen: boolean }) => { modalOpen: boolean }) | { modalOpen: boolean }
  ) => void;
};
